/* eslint-disable */
import { ReactComponent as LANG } from '@/assets/svg/language.svg'

import BaseModal from '@/components/Modal'
import { Button, Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from '@nextui-org/react'
import { useRef } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CLOSE } from '@/assets/icon/close.svg'
import { ReactComponent as SELECT } from '@/assets/svg/select.svg'
import { ReactComponent as SELECT_NO } from '@/assets/svg/select-no.svg'

const LangInit: {
	value: 'en' | 'zh' | 'ko' | 'ja' | 'ru' | 'th' | 'vi' | 'id' | 'tr'
	label: string
}[] = [
	{ value: 'en', label: 'English' },
	{ value: 'zh', label: '繁体中文' },
	{ value: 'ja', label: '日本語' },
	{ value: 'ko', label: '한국어' },
	{ value: 'ru', label: 'Русский' },
	{ value: 'vi', label: 'Tiếng Việt' },
	{ value: 'th', label: 'ภาษาไทย' },
	{ value: 'id', label: 'Indonesian' },
	{ value: 'tr', label: 'Türkçe' },
]

export default function LangModule() {
	const { i18n, t } = useTranslation()

	const { isOpen, onOpen, onClose, onOpenChange } = useDisclosure()

	const languageChange = (str: string) => i18n.changeLanguage(str)

	const languageChangeSwitch = (str: string) => {
		languageChange(str)

		toast.success(
			t('app.switch.language.tips', {
				msg:
					str === 'zh'
						? '中文'
						: str === 'ja'
							? '日本語'
							: str === 'ko'
								? '한국인'
								: str === 'ru'
									? 'Русский'
									: str === 'vi'
										? 'Tiếng Việt'
										: str === 'th'
											? 'ภาษาไทย'
											: str === 'id'
												? 'Indonesian'
												: str === 'tr'
													? 'Türkçe'
													: 'English',
			}),
			{ id: 'swtich-language', duration: 2000 },
		)
		onClose()
	}

	return (
		<div className="">
			<div onClick={() => onOpen()} className="flex items-center gap-2 rounded-full bg-white/15 px-2 py-1">
				<LANG className="cursor-pointer" />
				<span className="text-xs uppercase text-white">{LangInit.find(item => i18n.language === item.value)?.value}</span>
			</div>
			<Modal
				classNames={{
					base: '!m-0 w-full rounded-b-none rounded-t-xl border-transparent  sm:!mb-8 sm:w-96 sm:rounded-b-2xl',
				}}
				isOpen={isOpen}
				hideCloseButton
				scrollBehavior="inside"
				onOpenChange={onOpenChange}
			>
				<ModalContent>
					{onClose => (
						<>
							<ModalHeader className="flex items-center justify-between py-5">
								<div className="flex items-center justify-center gap-1">
									<LANG />
									<span className="text-lg font-bold text-white">{t('app.language')}</span>
								</div>
								<CLOSE onClick={onClose} className="cursor-pointer" />
							</ModalHeader>
							<ModalBody>
								<div className="flex flex-col gap-4 pb-10">
									{LangInit.map((item, key) => (
										<Button
											onClick={() => languageChangeSwitch(item.value)}
											key={key}
											className="flex w-full items-center justify-between bg-transparent px-0"
										>
											<span className="text-base text-white">{item.label}</span>
											{i18n.language === item.value ? <SELECT /> : <SELECT_NO />}
										</Button>
									))}
								</div>
							</ModalBody>
						</>
					)}
				</ModalContent>
			</Modal>
		</div>
	)
}
